import React, { useState } from 'react';
import { Button, Segmented } from "antd";
import styles from '../styles/sheetTable.module.css';
import { PlusOutlined } from "@ant-design/icons";
import SupplierSearchSelect from "../../../common/supplierSearchSelect";
import ICPartSearchSelect from "../../../common/icPartSearchSelect";
import StationSearchSelect from "../../../common/stationSearchSelect";
import ProductSearchSelect from "../../../common/productSearchSelect";

export default function SheetHeader(props) {

    const {
        onFilterChange, setShowModal, selectedSupplier, selectedIcPart, selectedStation, selectedProduct, selectedIsActive
    } = props;

    const [supplier, setSupplier] = useState(selectedSupplier);
    const [icPart, setIcPart] = useState(selectedIcPart);
    const [station, setStation] = useState(selectedStation);
    const [product, setProduct] = useState(selectedProduct);
    const [activeFilter, setActiveFilter] = useState(
        selectedIsActive === true ? "active" : selectedIsActive === false ? "inactive" : "all"
    );

    const isActiveOf = (filterValue) =>
        filterValue === "active" ? true : filterValue === "inactive" ? false : undefined;

    const handleSupplierChange = (supplier) => {
        setSupplier(supplier);
        onFilterChange(supplier, icPart, product, station, isActiveOf(activeFilter));
    };

    const handleICPartsChange = (icPart) => {
        setIcPart(icPart)
        onFilterChange(supplier, icPart, product, station, isActiveOf(activeFilter));
    };

    const handleStationChange = (station) => {
        setStation(station)
        onFilterChange(supplier, icPart, product, station, isActiveOf(activeFilter));
    };

    const handleProductChange = (product) => {
        setProduct(product)
        onFilterChange(supplier, icPart, product, station, isActiveOf(activeFilter));
    };

    const handleActiveFilterChange = (value) => {
        setActiveFilter(value);
        onFilterChange(supplier, icPart, product, station, isActiveOf(value));
    };

    return (<>
            <div>
                <div className={styles.headerRow2}>
                    <div className={styles.headerRow2Col1}>
                        <div className={styles.headerRow2Col1Container}>
                            <SupplierSearchSelect
                                onFilterChange={handleSupplierChange}
                                selected={selectedSupplier}
                            />
                            <ICPartSearchSelect
                                onFilterChange={handleICPartsChange}
                                selected={selectedIcPart}
                            />
                            <ProductSearchSelect
                                onFilterChange={handleProductChange}
                                selected={selectedProduct}
                            />
                            <StationSearchSelect
                                onFilterChange={handleStationChange}
                                selected={selectedStation}
                            />
                            <Segmented
                                options={[
                                    { label: "All", value: "all" },
                                    { label: "Active", value: "active" },
                                    { label: "Inactive", value: "inactive" },
                                ]}
                                value={activeFilter}
                                onChange={handleActiveFilterChange}
                            />
                        </div>
                    </div>
                    <div className={styles.headerRow2Col2}>
                        <Button type="primary" icon={<PlusOutlined />} onClick={() => {
                            setShowModal(true);
                        }}>New Sheet</Button>
                    </div>
                </div>
            </div>
    </>);
};